import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import BetaChip from './BetaChip';

function PageShell({ title, nav, children, maxWidth = 'lg' }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <Box sx={{ minHeight: '100vh' }}>
            <AppBar position="sticky">
                <Toolbar sx={{ gap: 1, py: 1.5 }}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1.25}
                        sx={{ flexGrow: 1, mr: 2, minWidth: 0 }}
                    >
                        <Typography variant="h6" noWrap>
                            {title}
                        </Typography>
                        <BetaChip />
                    </Stack>
                    {nav && (
                        isMobile ? (
                            <IconButton color="inherit" onClick={() => setDrawerOpen(true)} aria-label="Abrir menú">
                                <MenuIcon />
                            </IconButton>
                        ) : (
                            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
                                {nav}
                            </Stack>
                        )
                    )}
                </Toolbar>
            </AppBar>

            {nav && (
                <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                    <Box
                        sx={{
                            width: 240,
                            p: 3,
                            height: '100%',
                            color: '#ffffff',
                        }}
                        onClick={() => setDrawerOpen(false)}
                    >
                        <Stack
                            spacing={1.5}
                            alignItems="stretch"
                            sx={{
                                '& .MuiButton-root': { justifyContent: 'flex-start', color: 'inherit' },
                            }}
                        >
                            {nav}
                        </Stack>
                    </Box>
                </Drawer>
            )}

            <Container maxWidth={maxWidth} sx={{ py: { xs: 3, sm: 5 } }}>
                {children}
            </Container>
        </Box>
    );
}

export default PageShell;
